export default __webpack_public_path__ + "static/media/032-shark.48ed0b63.svg";